import Vue from 'vue'
import Router from 'vue-router'
import CanteenStaffSide from '@/components/CanteenStaffSide'
import CanteenCustomerSide from '@/components/CanteenCustomerSide'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/canteenStaffSide',
      name: 'canteen staff side',
      component: CanteenStaffSide
    },
    {
      path: '/canteenCustomerSide',
      name: 'canteen customer side',
      component: CanteenCustomerSide
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js